module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 192
// module chunks = 0